import { TelephoneType } from '../../utils/@globalTypes';
import { PayloadDataWithId } from './@types';
import { CertainDayPriceTypeList, BasePriceType } from './pricesTypes';
import { RentalObjectStatusesEnum } from './rentalObjectTypes';

export type BookingType = {
  id: number;
  children?: number[];
  phone: TelephoneType;
  check_in_date: string;
  check_out_date: string;
  check_in_time: string;
  check_out_time: string;
  adult: number;
  accommodation_price: string;
  paid: string;
  has_animals: boolean;
  animals_info?: string;
  status: BookingStatus;
  first_name: string;
  second_name?: string;
  last_name: string;
  // birth_day?: string
  nationality: string;
  email: string;
  telegram?: string;
  client_comment?: string;
  owner_comment?: string;
  rental_object: number;
  created_at: string;
  viewed: boolean;
  total_board_price: string;
  total_animal_price: string;
  animals_count: number;
};

export enum Gender {
  fem,
  mal,
}

export type BookingStatus = 'new' | 'que' | 'awt' | 'cfm' | 'cld';

export enum BookingFormType {
  view,
  edit,
  new,
}

export type RentalObjectShort = {
  id: number;
  name: string;
  base_price: BasePriceType;
  certain_day_prices: CertainDayPriceTypeList;
  status: RentalObjectStatusesEnum;
};

export type MainObjectShort = {
  id: number;
  name: string;
  rental_objects: RentalObjectShort[] | [];
};
export type ChessObjectsResponse = {
  count: number;
  next: number | null;
  previous: number | null;
  results: MainObjectShort[];
};
export type BookingListResponse = {
  count: number;
  next: number | null;
  previous: number | null;
  results: BookingType[];
};

export type UpdateBookingType = {
  children?: number[];
  phone?: TelephoneType;
  check_in_date?: string;
  check_out_date?: string;
  check_in_time?: string;
  check_out_time?: string;
  adult?: number;
  accommodation_price?: string;
  paid?: string;
  has_animals?: boolean;
  animals_info?: string;
  status?: BookingStatus;
  first_name?: string;
  second_name?: string;
  last_name?: string;
  // birth_day?: string
  nationality?: string;
  email?: string;
  telegram?: string;
  client_comment?: string;
  rental_object?: number;
  owner_comment?: string;
  viewed?: boolean;
  total_board_price?: string;
  total_animal_price?: string;
  animals_count?: number;
};

export type UpdateBookingPayloadData = PayloadDataWithId<UpdateBookingType>;

export type FormBookingType = {
  // phone: TelephoneType
  phone: string;
  check_in_date: Date;
  check_out_date: Date;
  check_in_time: string;
  check_out_time: string;
  adult: number;
  children?: number[];
  total: string;
  paid: string;
  rest: string;
  has_animals: boolean;
  animals_info: string;
  status: BookingStatus;
  first_name: string;
  second_name?: string;
  last_name: string;
  nationality: string;
  email: string;
  telegram: string;
  client_comment: string;
  rental_object: number | undefined;
  owner_comment: string;
  meals_costs: string;
  living_costs: string;
  animals_costs: string;
  animals_count?: string;
  snapTotal?: string;
};

export type SelectState = {
  id: string;
  checked: boolean;
};

export type FormClosureObjectType = {
  rental_object: number | undefined;
  start_closure: Date;
  end_closure: Date;
  reason: string;
};

export type UpdateClosureObjectType = {
  rental_object?: number;
  start_closure?: string;
  end_closure?: string;
  reason?: string;
  id?: number;
};

export type PriceRequestType = {
  rental_object: number;
  check_in_date: string;
  check_out_date: string;
  adults: number;
  children: number[];
  animals_count: number;
};

export type PriceResponseType = {
  accommodation_price: string;
  total_animal_price: string;
  total_board_price: string;
};
